import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  timeout: 60000,
});

// Helpful error passthrough
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.data?.detail) {
      err.message = err.response.data.detail;
    }
    return Promise.reject(err);
  }
);
